import styled from 'styled-components'

import { outline } from 'components/Editor/styled/Outline'

import type { NavButtonStyles } from '../../helpers'

const BaseNavigationButtonStyled = styled.button<{
  $hover: { backgroundColor?: string }
  $button: NavButtonStyles
}>`
  transition: 0.3s;
  background-color: ${({ $button }) => $button.backgroundColor};
  &:hover {
    background-color: ${({ $hover }) => $hover.backgroundColor};
  }
  ${outline}
`

export default BaseNavigationButtonStyled
